import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { type CategoryDisplayText } from '@/views/build/features/category-display-text';
import { AccordionSelection, type CategorySelectorState } from '@/views/build/features/category-select-view';
export const SubjectSelection = ({
  categoryInfo,
  displayText
}: {
  categoryInfo: CategorySelectorState;
  displayText: CategoryDisplayText;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  const isSubjectSelectionActive = useMemo(() => {
    if (categoryInfo.semester.selectedSemesterNode) return true;
    if (categoryInfo.grade.selectedGradeNode) {
      if (!categoryInfo.semester.semesterNodes?.length) return true;
      return false;
    }
    if (categoryInfo.schoolType.selectedSchoolTypeNode) {
      if (!categoryInfo.grade.gradeNodes?.length) return true;
      return false;
    }
    return false;
  }, [categoryInfo.grade.selectedGradeNode, categoryInfo.semester.selectedSemesterNode, categoryInfo.semester.semesterNodes, categoryInfo.schoolType.selectedSchoolTypeNode, categoryInfo.grade.gradeNodes]);
  const error = useMemo(() => {
    // 과목 선택이 active한 상태가 아니면, 상위의 validation 결과 받지 않음
    if (!isSubjectSelectionActive) return undefined;
    return categoryInfo.errors.subject;
  }, [categoryInfo.errors.subject, isSubjectSelectionActive]);
  return <AccordionSelection value={categoryInfo.subject.selectedSubjectNode} subValue={categoryInfo.subject.selectedSubSubjectNode} label={t('build:category.subject')} options={categoryInfo.subject.subjectNodes ?? []} error={error} isActive={isSubjectSelectionActive} isEmpty={categoryInfo.subject.subjectNodes?.length === 0} onChange={categoryInfo.updateCategoryInfo} onSubChange={value => {
    categoryInfo.updateCategoryInfo(value);
  }} onHover={value => {
    displayText.updateHoverPreview({
      field: 'subject',
      value: value.nodeId,
      label: value.label
    });
  }} onHoverLeave={() => {
    displayText.clearHoverPreview('subject');
  }} onSubHover={value => {
    displayText.updateHoverPreview({
      field: 'subSubject',
      value: value.nodeId,
      label: value.label
    });
  }} onSubHoverLeave={() => {
    displayText.clearHoverPreview('subSubject');
  }} data-sentry-element="AccordionSelection" data-sentry-component="SubjectSelection" data-sentry-source-file="SubjectSelection.tsx" />;
};